import { Button } from "primereact/button";
import React from "react";
import { useNavigate } from "react-router-dom";

const NonExistPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div
      id="reservationPage"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        textAlign: "center",
        color: "#333",
        padding: "1rem",
      }}
    >
      <h1 style={{ fontSize: "6rem", margin: 0 }}>404</h1>
      <p style={{ fontSize: "1.5rem", marginBottom: "2rem" }}>
        Puslapis nerastas
      </p>
      <Button
        label="Į pagrindinį"
        onClick={() => navigate('/')}
        className="p-button-primary"
      />
    </div>
  );
};

export default NonExistPage;
